// @flow

import * as types from '../actionTypes';
import { invoice } from '../schemata';
import genericNestedReducer, {
  genericNestedSelectorSet,
  useGenericNested,
} from './genericNested';
import type { invoiceType } from '../../types';

const invoices = genericNestedReducer(types.GET_INVOICE_ASYNC);

export default invoices;

export const selectInvoice = genericNestedSelectorSet<invoiceType>(
  invoice,
  state => state.invoices,
);

export const useInvoices = {
  ...useGenericNested<invoiceType>(
    invoice,
    state => state.invoices,
    (state => state.sales) || (state => state.purchases),
  ),
  singleById: () => {
    throw new Error('This should not be used.');
  },
  metaSingleById: () => {
    throw new Error('This should not be used.');
  },
};
